import React from "react";
// layouts
import { Route } from "react-router-dom";

import Admin from "./containers/Admin/Admin";

import {
	Chart as Chartjs,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler,
	BarElement,
	ArcElement,
} from "chart.js";

Chartjs.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler,
	ArcElement,
	BarElement
);

const App = () => {
	return (
		<div className="h-full font-poppins">
			{/* <BrowserRouter> */}
			{/* <Switch>
					<Route path="/login" children={<Register />} />
					<Route path="/auth-success" children={<AuthSuccess />} /> */}
			<Route path="*" children={<Admin />} />
			{/* </Switch> */}
			{/* </BrowserRouter> */}
		</div>
	);
};

export default App;
